import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	input,
	output,
	viewChild,
} from '@angular/core';
import { DestroyService } from '@context/frontend/common';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton, TuiIcon } from '@taiga-ui/core';

export type WordmarkSize = 's' | 'm' | 'l' | 'xl' | 'xxl';

const FileAcceptImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];

@Component({
	selector: 'ctx-wordmark',
	standalone: true,
	imports: [TuiIcon, TuiButton, TranslocoModule],
	templateUrl: 'wordmark.component.html',
	styleUrl: 'wordmark.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DestroyService],
	host: {
		'[attr.size]': 'size()',
		'[attr.disabled]': 'disabled()',
		'[attr.can-click]': 'canUpload()',
		'[attr.tabindex.0]': 'canUpload()',
	},
})
export class WordmarkComponent {
	readonly fileUploadInputRef =
		viewChild<ElementRef<HTMLInputElement>>('fileUploadInput');

	readonly icon = input<string>('@tui.building');

	readonly src = input<string | null>(null);

	readonly size = input<WordmarkSize>('l');

	readonly disabled = input(false);

	readonly canUpload = input(false);

	readonly fileChange = output<File>();
	readonly fileRemove = output<void>();

	readonly accept = FileAcceptImageTypes.join(', ');

	onUploadImage() {
		if (!this.canUpload()) return;
		this.fileUploadInputRef()?.nativeElement?.click();
	}

	readonly onRemoveImage = () => this.fileRemove.emit();

	onFileChange() {
		const fileInput = this.fileUploadInputRef()?.nativeElement;
		if (!fileInput) return;

		const file = fileInput.files?.item(0);
		if (file) {
			this.fileChange.emit(file);
		}

		// Reset the input so the same file can be selected again
		fileInput.value = '';
	}
}
